export const buildDeploymentRedirect = (
  hash: string,
  repositoryFullSlug: string
) => {
  return (
    hash
      // remove duplicate /deployments/ part
      .replace('/deployments/', '/')
      // replace hashbang with destination url
      .replace('#!/', `/${repositoryFullSlug}/deployments/`)
  );
};

export const buildPipelinesRedirect = (
  hash: string,
  repositoryFullSlug: string
) => {
  const triggerKeys = ['/start', '/redeploy'];
  triggerKeys.forEach(triggerKey => {
    if (hash.endsWith(triggerKey)) {
      // eslint-disable-next-line no-param-reassign
      hash = hash.replace(
        hash.substring(hash.length - triggerKey.length, hash.length),
        `/trigger${triggerKey}`
      );
    }
  });

  if (hash.startsWith('#!/?')) {
    return `/${repositoryFullSlug}/pipelines`;
  }

  return (
    hash
      // replace hashbang with destination url
      .replace('#!/', `/${repositoryFullSlug}/pipelines/`)
      // remove from-email part
      .replace(/\/from-email$/, ``)
  );
};

export const buildQueryRedirect = (hash: string, query: string) => {
  if (hash.startsWith('#!/?')) {
    return hash.replace('#!/?', '?');
  }
  return query;
};
